module.exports = __webpack_public_path__ + "static/media/github.cab674a3.svg";